import { FLOWS_LOADING, FLOWS_SUCCESS, FLOWS_FAILED, FLOW_DELETE, FLOW_UPDATE,
    FLOWS_FILTER_LOADING, FLOWS_FILTER_SUCCESS, FLOWS_ADD_MORE, CLEAR_FLOW_STATUS,
    FLOWS_UPDATE_FILTERS, CLEAR_ALL_FLOWS, FLOWS_DUPLICATE
} from '../actions/flowBuilderFlows.action';
import { fbFlowsInterface } from '../models/flowBuilder.interface';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';

const initialState: fbFlowsInterface = {
    loading: true,
    error: false,
    message: "",
    data: [],
    total: 0,
    totalFlows: 0,
    filteredLoading: false,
    fetchOne: false,
    status: false,
    filters: {
        sortBy: "dateModified",
        search: "",
        services: ["all"],
        status: ["all"]
    }
}

const fbFlowReducer = (state: fbFlowsInterface = initialState, action: any) : fbFlowsInterface => {
    const { data } = state;
    switch (action.type) {
        case FLOWS_LOADING:
            return {
                ...state,
                error: false,
                loading: true,
                status: false
            }
        case FLOWS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                status: false,
                data: action.payload.respose.data,
                total: action.payload.respose.total,
                totalFlows: action.payload.respose.total
            }
        case FLOW_DELETE:
            remove(data, {id: action.payload.id});
            let fetchOne:boolean = false;
            if(state.total -1 > data.length){
                fetchOne = true;
            }
            return {
                ...state,
                data: data,
                error: false,
                total: state.total - 1,
                totalFlows: state.totalFlows -1,
                fetchOne: fetchOne,
                status: true,
                message: action.payload.message
            }
        case FLOWS_FAILED: 
            return {
                ...state,
                loading: false,
                filteredLoading: false,
                error: true,
                status: false,
                message: action.payload.error.message || ""
            }
        case FLOWS_DUPLICATE:
            return {
                ...state,
                error: false,
                status: true,
                data: [ ...action.payload.response.data, ...state.data],
                total: state.total + 1,
                totalFlows : state.total + 1,
                message: action.payload.response.message,
            }
        case FLOW_UPDATE:
            const index = findIndex(data, {id: action.payload.id});
            const item = data[index];
            item.status = action.payload.status;
            data.splice(index, 1, item);
            return {
                ...state,
                error: false,
                data: data,
                status: true,
                message: action.payload.message
            }
        case FLOWS_FILTER_LOADING:
            return {
                ...state,
                error: false,
                filteredLoading: true,
                status: false,
            }
        case FLOWS_FILTER_SUCCESS:
            return {
                ...state,
                error: false,
                message: "",
                status: false,
                loading: false,
                filteredLoading: false,
                data: action.payload.respose.data,
                total: action.payload.respose.total,
            }
        case FLOWS_ADD_MORE: 
            return {
                ...state,
                error: false,
                fetchOne: false,
                status: false,
                data: [...state.data, ...action.payload.respose.data],
                total: action.payload.respose.total
            }
        case CLEAR_FLOW_STATUS:
            return {
                ...state,
                error: false,
                status: false,
                message: ""
            }
        case FLOWS_UPDATE_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    search: action.payload.searchString,
                    services: action.payload.selectedChannels,
                    status: action.payload.selectedStatus,
                    sortBy: action.payload.selectedSort
                }
            }
        case CLEAR_ALL_FLOWS: 
            return {
                ...initialState,
                filters: {
                    ...initialState.filters
                }
            }
        default:
            return state;
    }
}

export default fbFlowReducer;